import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactLoading from 'react-loading';
import { primarycolor } from "../Utils/colors";
import { Changepassurl, Fetchsharedprofilesurl } from "./../Utils/urls";
import styles from "./../Hostels/houses.module.css";
import { FaDollarSign, FaStarOfLife } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";
import { getsessionuser } from './../Utils/sessions';
import Universalheader from "../Headers/universalheader";
import { Alert, AlertTitle, Container, InputAdornment, Modal, TextField } from "@mui/material";
import SignIn from "../Common/login";
import { ChevronRight, Clear, CurrencyExchange, MoveDown, Receipt, ReceiptOutlined, Search } from "@mui/icons-material";
import Yourprofile from "./yourprofile";
import Shuffle from "../Utils/shuffle";
import Partnerprofile from "./partnerprofile";
import Loadingspinner from "../Components/loading";
import { prices } from "../Utils/arrays";



let color = "white";
let type = "spokes";


const Roommates = ({onrefresh}) => {

    const navigate = useNavigate();


    const sessionuser = getsessionuser();
    const [user, setuser] = useState(sessionuser);

    //modals
    const [showlogin, setshowlogin] = useState(false);
    const [showfund, setshowfund] = useState(false);
    const [showyourprofile, setshowyourprofile] = useState(false);
    const [showpartnerprofile, setshowpartnerprofile] = useState(false);

    const [users, setusers] = useState([]);
    const [displayedusers, setdisplayedusers] = useState([]);
    const [partnerinplay, setpartnerinplay] = useState('');

    //filters
    const [pricefilter, setpricefilter] = useState('');


    const [loading, setloading] = useState(false);
    const [error, seterror] = useState('');
    const [hint, sethint] = useState('');

    //search bar
    const [showClearIcon, setShowClearIcon] = useState('none');



    useEffect(() => {
        if (!user) {
            setshowlogin(true)
        } else {
            if (user?.sharingstatus == 1) {
                fetchusers()
            }
        }
    }, []);





    //fetch roommates
    const fetchusers = () => {
        setloading(true)
        seterror(null)
        axios.post(Fetchsharedprofilesurl, {

        }).then(response => {
            setloading(false)
            if (!response.data.error) {
                setusers(Shuffle(response.data))
                setdisplayedusers(Shuffle(response.data))
            } else {
                seterror(response.data.message)
            }
            // 
        }).catch(error => {
            setloading(false)
            seterror("Sorry an error occurred,try again later");
        });

    }



    const Searchlogic = () => {//serch users that have already been fetched
        var result = [];
        users.forEach(element => {
            if (element.username?.toLowerCase().replace(/\s+/g, '').match(hint?.toLowerCase().replace(/\s+/g, ''))) {
                result.push(element)
            }
        });
        return result;
    }



    //search room mate 
    const search = (hint) => {
        if (!hint) {
            setdisplayedusers(users)
        } else {
            const gottendata = Searchlogic()
            if (gottendata.length > 0) {
                setdisplayedusers(gottendata)
            } else {
                setdisplayedusers([])
                seterror("no users matches the search query")
                setTimeout(() => {
                    seterror()
                }, 3000);
            }
        }
    }

    const handleChange = (event) => {
        setShowClearIcon(event.target.value === "" ? "none" : "flex");
        sethint(event.target.value)
        search(event.target.value)
    }



    //clear serach
    const clearsearch = () => {
        setdisplayedusers(users)
        setShowClearIcon("none")
        sethint()
    }



    const onsuccesslogin = () => {
        fetchusers()
        setshowlogin(false)
        onrefresh()
    }


    //fund account functions
    const onsuccessfund = () => {//on successfund
        fetchusers()
        onrefresh()
        setshowyourprofile(false)
        setshowpartnerprofile(false)

    }
    const onfailfund = () => {//on fail fund

    }
    const oncancelfund = () => {// in cancel fund modal
        setshowyourprofile(false)
        setshowpartnerprofile(false)
    }


    return (
        <div className={styles.container}>
            <div className={styles.topheader} style={{ paddingBottom: 100 }}>
                {loading && <Loadingspinner />}
                {/* {error?.length > 0 &&
                    <Alert severity="error">
                        <AlertTitle>Error</AlertTitle>
                        {error} — <strong>check it out!</strong>
                    </Alert>} */}
                <Universalheader refresh={showlogin} />
                <Modal
                    open={showlogin}
                    onClose={() => {
                        setshowlogin(false)
                        navigate("/nav/home")
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <SignIn onsuccesslogin={onsuccesslogin} />
                </Modal>
                <Modal
                    open={showyourprofile}
                    onClose={() => setshowyourprofile(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Yourprofile onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} />
                </Modal>
                <Modal
                    open={showpartnerprofile}
                    onClose={() => setshowpartnerprofile(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Partnerprofile onsuccessfund={onsuccessfund} onfailfund={onfailfund} oncancelfund={oncancelfund} partner={partnerinplay} />
                </Modal>
                <div className={styles.advertisediv}>
                    <FaStarOfLife color={primarycolor} size={15} />
                    <Link to="">
                        <a onClick={() => setshowyourprofile(true)}>Your profile status</a>
                    </Link>
                 
                </div>

                <div className={styles.housenamediv}>
                    <div className={styles.housenamehead}>ROOMMATES   <text style={{fontSize:12,fontStyle:"italic"}}>(Note. To view other users profile you need to set your sharing status as active)</text> </div>
                    <div>

                    </div>
                </div>
                <div className={styles.linksdiv}>
                    <Link to="/">
                        <a>Home  /</a>
                    </Link>
                    <a onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>back  /</a>
                </div>
                <div>
                    <div className={"wrapwalletdiv"}>
                        <div className="filterdiv">
                            <div className={"selectdiv"}>
                                Name:
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    value={hint}
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment
                                                onClick={() => search()}
                                                position="start"
                                                style={{ cursor: "pointer" }}>
                                                <Search />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment
                                                position="end"
                                                style={{ display: showClearIcon, cursor: "pointer" }}
                                                onClick={() => clearsearch()}
                                            >
                                                <Clear />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>

                            {/* <div className={"selectdiv"}>
                                Budget:
                                <Select menuPlacement="bottom" options={prices} onChange={e => setpricefilter(e.value)} ></Select>
                            </div> */}
                        </div>
                        <div className="wraproommates">
                            {displayedusers?.map((val, key) => {

                                return (
                                    <div className="roommatediv" key={key} onClick={() => {
                                        setpartnerinplay(val)
                                        setshowpartnerprofile(true)
                                    }}>
                                        <p align="middle">
                                            <img src={val?.profile_url ? val.profile_url : require("./../../assets/common/image2.png")} />
                                        </p>
                                        <div>
                                            <b>{val?.username}</b><br />
                                            {val?.gender.substring(0, 20)}<br />
                                            <b>{val?.budget}</b> Ksh<br />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Roommates;